import { AnalyticsService } from './../analytics/analytics.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Contribution, ThankYouCampaign } from './../track/contribution';
import { Upload } from './../uploads/shared/upload';
import { BaseObject } from './../shared/baseClass';

import { AuthService, User } from './../user/auth.service';
import { Category } from './../unsplash/unsplash.response';
import { Observable } from 'rxjs/Observable';
import { EventEmitter, Injectable } from '@angular/core';
import { Gift } from '../gift/gift';
import { GiftSelection } from '../gift/giftSelection';
import { ConfigurationService } from '../shared/configuration.service';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Registry, Section } from '../registry/registry';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/toPromise';
import { ICategoryImages } from '../create-gift/ICategoryImages';
import { CartItem } from '../cart/cartItem';
import { URLSearchParams, QueryEncoder } from '@angular/http';
import { CreateGiftModel } from '../create-gift/create-gift-model';
import 'rxjs/add/operator/catch';
import { take, map } from 'rxjs/operators';
import { IPayment } from '../IPayment';
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
  
  
} from 'angularfire2/firestore';

import { Settings } from '../settings/settings';
import { ImageUrlService } from '../shared/services/image-url.service';

import * as Stripe from 'stripe';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { StarterRegistry, TemplateGift } from '../templates/starter-registry';
import { Website } from '../website-builder/wedding';

@Injectable()
export class RegistryFirebaseService {


  firebaseGifts = 'registry-gifts';
  firebaseTableNames_Registries = 'registries';
  firebaseTableNames_Settings = 'settings';
  firebaseTableNames_ThankYou = 'thankyou-campaigns';
  tablename_processedPayments = 'proccessed-payments';
  tablename_giftPayments = 'gift-payments';
  firebaseTableNames_thankyouCardSends = 'thankyou-card-sends';
  words = [
    "apple", "banana", "cherry", "date", "elderberry", "fig", "grape", "honeydew", "kiwi", "lemon",
    "mango", "orange", "papaya", "quince", "raspberry", "strawberry", "tangerine", "watermelon", "avocado", "blackberry",
    "blueberry", "coconut", "dragonfruit", "guava", "jackfruit", "kiwifruit", "lime", "lychee", "melon", "nectarine",
    "olive", "peach", "pear", "pineapple", "plum", "pomegranate", "apricot", "grapefruit", "mulberry", "boysenberry",
    "rhubarb", "cantaloupe", "clementine", "cranberry", "currant", "durian", "gooseberry", "kiwano", "kumquat", "mandarin",
    "passionfruit", "persimmon", "quinoa", "soursop", "starfruit", "ugli fruit", "yuzu", "zucchini",,
    "carrot", "celery", "cucumber", "eggplant", "garlic", "ginger", "kale", "leek", "lettuce", "mushroom",
    "onion", "pepper", "potato", "pumpkin", "radish", "spinach",, "tomato", "turnip", "zucchini",
    "almond", "cashew", "chestnut", "coconut", "hazelnut", "macadamia", "peanut", "pecan", "pistachio", "walnut",
    "beef", "chicken", "duck", "goat", "lamb", "pork", "rabbit", "turkey", "veal", "venison",
    "bacon", "ham", "sausage", "salmon", "tuna", "shrimp", "lobster", "crab", "scallop", "oyster",
    "asparagus", "broccoli", "cauliflower", "corn", "pea", "bell pepper", "carrot", "celery", "cucumber",
    "lettuce", "mushroom", "onion", "potato", "pumpkin", "spinach", "squash",  "tomato", "zucchini",
    "bagel", "bread", "croissant", "doughnut", "muffin", "pastry", "pretzel", "scone", "toast", "waffle",
    "biscuit", "cake", "cookie", "cupcake", "pie", "brownie", "macaron", "cheesecake", "pudding",
    "coffee", "espresso", "latte", "cappuccino", "mocha", "americano", "macchiato", "frappuccino", "chai", "tea",
    "baguette", "ciabatta",  "naan", "pita", , "sourdough", "tortilla", "chickpeas",, "soybeans",
    "barley", "bulgur", "couscous", "farro", "millet", "oats", "quinoa",
   , "hamburger", "lasagna", "meatballs", "pizza", "spaghetti bolognese", "sushi", "tacos",
    , "brownies", "cheesecake", "chocolate chip cookies", "cinnamon rolls", "creme brulee", "cupcakes", "donuts", "pancakes",
    "amaretto", "gin", "margarita", "mojito", "rum", "sangria", "tequila", "vodka", "whiskey", "wine",
    "baseball", "basketball", "boxing", "cricket", "football", "golf", "hockey", "rugby", "soccer", "tennis",
    "ballet", "contemporary", "hip hop", "jazz", "salsa", "samba", "tap", "tango", "breakdancing", "flamenco",
    "astronomy", "biology", "chemistry", "geology", "mathematics", "physics", "psychology", "sociology", "zoology",
    "acoustic guitar",  "drums", "electric guitar", "keyboard", "piano", "saxophone", "trumpet", "violin", "xylophone",
    "beach", "forest", "mountain", "ocean", "park", "river", "desert", "lake", "waterfall", "cave",
    "autumn", "winter", "spring", "summer", "rainy", "sunny", "cloudy", "windy", "snowy", "foggy",
    "adventure", "comedy", "drama", "fantasy", "horror", "mystery", "romance", "science fiction", "thriller", "western",
    "art", "dance", "film", "literature", "music", "photography", "theater", "sculpture", "architecture", "fashion"
  
  ];

  gistryName: string;
  settingsDocumentId = '';
  settingsDocument: AngularFirestoreDocument<Settings>;
  giftsCollectionRef: AngularFirestoreCollection<Gift>;
  registryCollectionRef: AngularFirestoreCollection<Registry>;
  selectedGift: Gift;
  paymentAmount: number;
  paymentCollectionRef: AngularFirestoreCollection<IPayment>;
  gifts$: Observable<Gift[]>;
  registry$: Observable<Registry>;
  payments$: Observable<IPayment[]>;
  localGifts: Array<Gift>;
  user: User;
  gifts: Gift[];
  registry: Registry;
  private registrySource = new BehaviorSubject<Registry>(null);
  private giftsSource = new BehaviorSubject<Gift[]>(null);
  private settingsSource = new BehaviorSubject<Settings>(null);
  public currentRegistry: Observable<Registry> = this.registrySource.asObservable();
  showMiniLaunch: boolean = false;
  showMiniLaunchChanged: EventEmitter<[boolean, boolean]> = new EventEmitter<[boolean, boolean]>();


  public currentGifts: Observable<Gift[]> = this.giftsSource.asObservable();
  public currentSettings: Observable<Settings> = this.settingsSource.asObservable();
  contributionCount = 0;
  // Add near other BehaviorSubject/Observable declarations
  private initialMiniLaunchState = new BehaviorSubject<[boolean, boolean]>([false, false]);

  // Add this near other class properties
  private moveGiftToSectionSource = new Subject<Gift>();
  moveGiftToSection$ = this.moveGiftToSectionSource.asObservable();

  constructor(
    private afs: AngularFirestore,
    private _authService: AuthService,
    private _analyticsService: AnalyticsService,
    private imageUrlService: ImageUrlService,
  ) {
    // this.init();

    this._authService.user.subscribe(user => {

      this.user = user;
      if (this.user && this.user.registryId) {
        this.getGiftsforRegistry(this.user.registryId).subscribe(gifts => {
          if (this.registry && this.registry.id === this.user.registryId) {
            this.gifts = gifts;
            this.giftsSource.next(gifts);
          }
        });
      }
    });

    if (localStorage.key['local-gifts']) {
      let giftString = localStorage['local-gifts'];
      this.localGifts = JSON.parse(giftString) as Gift[]
    }

  }

  openVisibility(router:Router, registry:Registry, website: Website){
 //   return  router.navigate(['/visibility']);
    if ((registry && registry.paid )|| (website && website.paid)){
    return  router.navigate(['/visibility']);
    } else if (registry && !registry.paid || (!website || !website.paid)){
      this.showMiniLaunchPopup(true);
    }
    
  }

  isAnonRegPath(): boolean {
    return location.pathname.includes('your-registry')
  }
 

   
  createSectionWithGifts(destinationName: string, giftsForDestination: TemplateGift[], isAiGifts: boolean = false) {
 
    
    let giftIds = [];
    giftsForDestination.forEach(gift => {   
      const templateId = gift.id;
      gift.fromRegistry = destinationName
      if(templateId){
      gift.templateGiftId = templateId;
      gift.fromTemplate = true;
      }
      gift.id = null;

      let tempId = this.afs.createId();
      giftIds.push(tempId);
      this.addGift(gift, this.registry,tempId )
      
    });
    
    if(!this.registry){
      
    }
    if(!this.registry.sections){
      this.registry.sections = [];
    }
     this.registry.sections.push(
      {
        name: destinationName,
        giftIds: giftIds,
      
      }
    )
   
    if(isAiGifts){
      this.registry.hasAiGifts = true;
    }
    
    this.saveRegistry(this.registry)
    
    

  }
  currentRegGifts(regId: string): Observable<Gift[]> {

    if (
      this.gifts &&
      this.gifts.filter(x => x.registryId === regId).length ===
      this.gifts.length
    ) {
      return Observable.of(this.gifts);
    }

    return this.getGiftsforRegistry(regId).switchMap(gifts => {
      this.gifts = gifts;
      return Observable.of(gifts);
    });
  }
  currentReg(regName: string): Observable<Registry> {

    if (
      this.registry &&
      this.registry.registryName.toLowerCase() === regName.toLowerCase()
    ) {
      return Observable.of(this.registry);
    } else {
      return this.registryByName(regName);
    }
  }

  //  this.currentRegistry.switchMap((reg) => {
  //   if (reg || reg.registryName != regName) {
  //    // return this.registryByName(regName);
  //   } else {
  //    // return reg;
  //   }
  // });

  init(user) {
    this.initGiftsForUser(user);
  }
  getCurrencyForCountry(country) {
    let currency = 'USD';
    switch (country) {
      case 'AU': {
        currency = 'AUD';
        break;
      }
      case 'CA': {
        currency = 'CAD';
        break;
      }
      case 'GB': {
        currency = 'GBP';
        break;
      }
      case 'NZ': {
        currency = 'NZD';
        break;
      }
      case 'US': {
        currency = 'USD';
        break;
      }
      case 'US': {
        currency = 'USD';
        break;
      }
      case 'AT': {
        currency = 'EUR';
        break;
      } case 'BE': {
        currency = 'EUR';
        break;
      }
      case 'ES': {
        currency = 'EUR';
        break;
      }
      case 'EE': {
        currency = 'EUR';
        break;
      } case 'FI': {
        currency = 'EUR';
        break;
      } case 'FR': {
        currency = 'EUR';
        break;
      } case 'DE': {
        currency = 'EUR';
        break;
      } case 'GR': {
        currency = 'EUR';
        break;
      } case 'IE': {
        currency = 'EUR';
        break;
      } case 'IT': {
        currency = 'EUR';
        break;
      } case 'LV': {
        currency = 'EUR';
        break;
      } case 'LT': {
        currency = 'EUR';
        break;
      } case 'LU': {
        currency = 'EUR';
        break;
      } case 'NL': {
        currency = 'EUR';
        break;
      } case 'PT': {
        currency = 'EUR';
        break;
      }
      case 'SG': {
        currency = 'SGD';
        break;
      }
      case 'HK': {
        currency = 'HKD';
        break;
      }
      case 'US': {
        currency = 'USD';
        break;
      }

      case 'SE': {
        currency = 'SEK';
        break;
      }

      case 'NO': {
        currency = 'NOK';
        break;
      }
      case 'CH': {
        currency = 'CHF';
        break;
      }


      default: {
        currency = 'USD';
        country = 'US';
      }
    }
    return currency;
  }
  getAnonRegistry(): Registry {


    let registry: Registry;

    const country = localStorage.getItem('country');
    let regString = localStorage.getItem('anon-reg');;
    if (regString) {
      registry = JSON.parse(regString) as Registry
      if (country || (registry.country && !registry.currency)) {
        registry.currency = this.getCurrencyForCountry(country);
        registry.symbol = this.currencySymbol(registry)
      }
      if (!registry.symbol) {
        registry.symbol = this.currencySymbol(registry)
      }
    } else {
      ;
      let registry = new Registry();
      if (country || (registry.country && !registry.currency)) {
        registry.currency = this.getCurrencyForCountry(country);
        registry.symbol = this.currencySymbol(registry)
      }
      if (!registry.symbol) {
        registry.symbol = this.currencySymbol(registry)
      }
      registry.fromAnonymous = true;
      registry.weddingDay = 31;
      registry.weddingMonth = 12;
      registry.weddingYear = new Date().getFullYear() + 1
      registry.firstName = "You"
      //registry.textColour = "#fff"

      registry.font = 'classic';



      registry.imageShape = 'arc';

      registry.partnerFirstName = "Partner";
      registry.backgroundHeaderImageUrl = 'https://images.unsplash.com/photo-1527904219733-fddc74937915?hex=#1A1E1B';
      registry.introTitle = 'Welcome to our registry';
      registry.introductionText =
        'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.';


      localStorage.setItem('anon-reg', JSON.stringify(registry));

      if (!country)
        registry.currency = 'USD';
      registry.country = 'US';
      registry.symbol = '$';
    }

    this.registry = registry;
    return registry;



  }

  saveAnonRegistry(registry: Registry) {
    console.log(registry)
    localStorage.setItem('anon-reg', JSON.stringify(registry));
    this.registry = registry;
    this.registrySource.next(registry);
  }

  initLoadingReg(registry: Registry, router: Router, user: User) {

    if (registry) {
      if (router.url === '/get-started') {
        return;
      }
      
      if (user && user.registryId !== registry.id && !registry.isLive) {
        router.navigate(['/coming-soon'], { skipLocationChange: true });
      } else if (!user && router.url.endsWith('/registry')) {
        router.navigate(['/login']);
      } else if (!user && !registry.isLive) {
        router.navigate(['/coming-soon'], { skipLocationChange: true });
      }
    } else {
      router.navigate(['/404'], { skipLocationChange: true });
    }
  }

  killLoader() {
    const loader = document.getElementById('reg-loader');
    if (loader) {
      loader.remove(); //
    }

  }

  initGiftsForUser(user: User) {

    //  this.user = user;
    if (!user) {
      return null;
    }

    if (user.registryId) {
      //    console.log("reg 1")
      this.registryForUser(user)
        .take(1)
        .subscribe(registry => {
          //    console.log("reg 2");
          if (registry) {
            //    console.log("xxxxx about to set gifts");
            this.setGifts(registry);
          }
        });

      this.user = user;
      if (user.registryId) {

        this.giftsCollectionRef = this.afs.collection<Gift>(
          'registry-gifts',
          ref => ref.where('registryId', '==', user.registryId)
        );
        this.settingsDocumentId = user.registryId + user.uid;
        // this.giftsForRegistry().subscribe(gifts => {
        //   this.giftsSource.next(gifts);

        // });

        this.getSettings().subscribe(settings => {

          this.settingsSource.next(settings);
        });
      } else {
        this.registry$.subscribe(registry => {
          if (registry && registry.id) {

            // console.log("xxxxx got new reg");

            this.giftsCollectionRef = this.afs.collection<Gift>(
              'registry-gifts',
              ref => ref.where('registryId', '==', registry.id)
            );
            // this.giftsForRegistry().subscribe(gifts => {
            //   this.giftsSource.next(gifts);

            // });
          }
        });
      }
    }
  }

  createStripeAccount(registry: Registry) {

    // const stripe = require('stripe')('sk_test_aSpzKykhkbZ37mYri1QuJZ2b');
    const created = false;
    this._authService.user.subscribe(user => {
      if (!created) {
        // const stripe = new Stripe('sk_test_aSpzKykhkbZ37mYri1QuJZ2b');
        // stripe.resources.Accounts.prototype.create
        //   ({
        //     country: registry.country,
        //     type: 'standard',
        //     email: user.email
        //   }, function (err, account) {
        //
        //     if (err) {
        //
        //     }
        //     created = true;
        //     user.stripeAccountId = account.id;
        //     user.secret = account.object;
        //     user.publishKey = account.business_name;
        //     //    this.afs.collec
        //     // asynchronously called
        //   });
      }
    });
  }



  currencySymbol(registry: Registry): string {
    if (!registry || !registry.currency) {
      return;
    }
    const currency = registry.currency.toLowerCase();
    let symbol = '';
    switch (currency) {
      case 'aud': {
        return (symbol = '$');
      }
      case 'mxn': {
        return (symbol = '$');
      }
      case 'dkk': {
        return (symbol = 'Kr');
      }
      case 'sek': {
        return (symbol = 'Kr');
      }
      case 'nok': {
        return (symbol = 'Kr');
      }
      case 'chf': {
        return (symbol = 'CHF ');
      }


      case 'usd': {
        return (symbol = '$');
      }
      case 'hkd': {
        return (symbol = '$');
      }
      case 'sgd': {
        return (symbol = '$');
      }
      case 'gbp': {
        return (symbol = '£');
      }
      case 'eur': {
        return (symbol = '€');
      }
      case 'cad': {
        return (symbol = '$');
      }

      case 'nzd': {
        return (symbol = '$');
      }
      case 'yen': {
        return (symbol = '¥');
      }
    }
  }


  getCardSends(userId): Observable<any[]> {

    return this.afs
      .collection<any>(this.firebaseTableNames_thankyouCardSends, ref =>
        ref.where('userId', '==', userId)
      )
      .valueChanges()
      .map(actions => {

        return actions
          .map(thankYouSend => {

            return thankYouSend;
          });

      });
  }

  getSettings(): Observable<Settings> {

    return this.afs
      .collection<Settings>(this.firebaseTableNames_Settings, ref =>
        ref.where('userId', '==', this.user.uid)
      )
      .snapshotChanges()
      .map(x => {
        if (x && x.length > 0 && x[0].payload) {
          const settings = x[0].payload.doc.data() as Settings;
          settings.id = x[0].payload.doc.id;
          return settings;
        }
      });
  }
  getSettingsByUserId(userId): Observable<Settings> {
    return this.afs
      .collection<Settings>(this.firebaseTableNames_Settings, ref =>
        ref.where('userId', '==', userId)
      )
      .snapshotChanges()
      .pipe(
        map(x => {
          if (x && x.length > 0 && x[0].payload) {
            const settings = x[0].payload.doc.data() as Settings;
            settings.id = x[0].payload.doc.id;
            return settings;
          }
          return null;
        }),
        take(1) // Complete after first emission
      );
  }


  getSettingsViaReg(registry: Registry): Observable<Settings> {
    return this.afs
      .collection<Settings>(this.firebaseTableNames_Settings, ref =>
        ref.where('userId', '==', registry.userId)
      )
      .snapshotChanges()
      .pipe(
        map(x => {
          if (x && x.length > 0 && x[0].payload) {
            const settings = x[0].payload.doc.data() as Settings;
            settings.id = x[0].payload.doc.id;
            return settings;
          }
          return null;
        }),
        take(1) // Complete after first emission
      );
  }


  getSettingsForUser(userId: string, registryId: string): Observable<Settings> {

    return this.afs
      .collection<Settings>(this.firebaseTableNames_Settings).doc(registryId + userId)
      .snapshotChanges()
      .map(x => {
        if (x && x.payload) {
          const settings = x.payload.data() as Settings;
          settings.id = x.payload.id;
          return settings;
        }
      });
  }


  setCampaign(thankYouCard: ThankYouCampaign, userId: string): Promise<void> {
    const now = Date.now();
    if (!thankYouCard.createdDate) {
      thankYouCard.createdDate = now;
    }
    thankYouCard.modifiedDate = now;
    let thankYouObject = JSON.stringify(thankYouCard);
    return this.afs
      .collection<ThankYouCampaign>(this.firebaseTableNames_ThankYou)
      .doc(userId)
      .set({
        thankYouCard: JSON.parse(thankYouObject)
      }, { merge: true });

  }
  updateContributionThankYouCard(thankYouCard: ThankYouCampaign, contriubtionId: string): Promise<void> {
    const now = Date.now();
    if (!thankYouCard.createdDate) {
      thankYouCard.createdDate = now;
    }
    thankYouCard.modifiedDate = now;
    let thankYouObject = JSON.stringify(thankYouCard);
    return this.afs
      .collection<Contribution>(this.tablename_processedPayments)
      .doc(contriubtionId)
      .set({
        thankYouCard: JSON.parse(thankYouObject)
      }, { merge: true });

  }

  // coupleThankYou: string;
  // coupleThankYouImageUrl: string;
  updateContribution(
    paymentId: string,
    coupleThankYou: string,
    coupleThankYouImageUrl: string,
    seen: boolean,
    isPhysicalThankYouCard: boolean
  ) {
    if (coupleThankYouImageUrl == null) {
      coupleThankYouImageUrl = '';
    }
    if (coupleThankYou == null) {
      coupleThankYou = '';
    }
    this.afs
      .collection<Contribution>(this.tablename_processedPayments)
      .doc(paymentId)
      .update({
        coupleThankYouImageUrl: coupleThankYouImageUrl,
        coupleThankYou: coupleThankYou,
        seen: seen,
        coupleThankYouDateTime: Date.now()
      });
    this._analyticsService.trackEvent('thank-you-created', {
      coupleThankYouImageUrl: coupleThankYouImageUrl,
      coupleThankYou: coupleThankYou,
      coupleThankYouDateTime: Date.now(),
      isPhysicalThankYouCard: isPhysicalThankYouCard
    });
  }

  getContributionsRemaining(registry: Registry, contributions: Contribution[]) {

    let limit = this.getContributionLimit(this.registry);
    return limit - contributions.length;


  }


  getContributionLimit(registry: Registry) {
    ;
    let max = null;
    if (registry && registry.tier == 'small') {
      max = 25;
    } else if (registry && registry.tier == 'medium') {
      max = 50;
    } else {
      max = 0;
    }

    if (max == 0) {
      return null;
    }

    return max;


  }

  getDeletedContributions(): Observable<Contribution[]> {
    let counter = 1;
    let contributionCount = 0;


    return this.afs
      .collection<Contribution>(this.tablename_processedPayments, ref =>
        ref.where('userId', '==', this.user.uid)
      )
      .snapshotChanges().map
      (actions => {

        return actions.filter(action => {
          return action
            && action.payload.doc
            && action.payload.doc.data().deleted
        }).map(x => {

          if (x) {
            const contribution = x.payload.doc.data() as Contribution;
            contribution.number = counter;
            contribution.id = x.payload.doc.id;
            counter++;
            contributionCount++;
            return contribution;

          }
        })

      })
  }
  toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

  getContributionsbyStatus(contributions: Contribution[], status: string): Contribution[] {

    if (status == 'paid') {

      return contributions.filter(x => x.paymentStatus == 'paid' || !x.paymentStatus);
    } else {
      return contributions.filter(x => x.paymentStatus == status);
    }



  }



  getContributions(gifts: Gift[], registry:Registry = null): Observable<Contribution[]> {
    let counter = 1;
    let contributionCount = 0;


    return this.afs
      .collection<Contribution>(this.tablename_processedPayments, ref =>
        ref.where('userId', '==', this.user.uid)
      )
      .snapshotChanges().map
      (actions => {

        return actions.filter(action => {
          return action
            && action.payload.doc
            && !action.payload.doc.data().deleted
        }).map(x => {

          if (x) {
            const contribution = x.payload.doc.data() as Contribution;
            contribution.number = counter;
            contribution.id = x.payload.doc.id;

            if (contribution.paymentStatus == 'paid' || !contribution.paymentStatus) {



              if (contribution.isManualContribution) {
                contribution.friendlyPaymentMethod = this.toTitleCase(contribution.manualPaymentMethod);
                if (contribution.stripePaymentId.toLowerCase().startsWith('custom')) {
                  contribution.friendlyPaymentMethod = "Custom Instructions"
                }
                if (contribution.friendlyPaymentMethod.toLowerCase().startsWith('cashon')) {
                  contribution.friendlyPaymentMethod = "Cash"
                }

                else if (contribution.friendlyPaymentMethod.toLowerCase().startsWith('cheque')) {
                  contribution.friendlyPaymentMethod = "Cheque"
                }
                else if (contribution.manualPaymentMethod == 'paypal') {
                  contribution.friendlyPaymentMethod = "PayPal"
                }
                else if (contribution.manualPaymentMethod == 'bank') {
                  if(registry){
                  let bank1Country = registry.bankCountry? registry.bankCountry: registry.country
                  contribution.friendlyPaymentMethod = "Bank Transfer ("+bank1Country+")";
                  } else {
                    contribution.friendlyPaymentMethod = "Bank Transfer"
                  }
                }

                else if (contribution.manualPaymentMethod == 'bank2') {
                  if(registry){
                  let bank2Country = registry.bank2Country;
                  contribution.friendlyPaymentMethod = "Bank Transfer ("+bank2Country+")";
                  } else {
                    contribution.friendlyPaymentMethod = "Bank Transfer"
                  }
                }

                else if (contribution.manualPaymentMethod == 'bank3') {
                  if(registry){
                    let bank3Country = registry.bank3Country;
                    contribution.friendlyPaymentMethod = "Bank Transfer ("+bank3Country+")";
                    } else {
                      contribution.friendlyPaymentMethod = "Bank Transfer"
                    }
                }
                else if (contribution.manualPaymentMethod.toLowerCase() == 'cashapp') {
                  contribution.friendlyPaymentMethod = "Cash App"
                }
                else if (contribution.manualPaymentMethod.toLowerCase() == 'payid') {
                  contribution.friendlyPaymentMethod = "Email/Phone"
                }
              } 
              else if(contribution.isPayEngine){
                contribution.friendlyPaymentMethod = "Credit Card"
              }
              
              else {
                contribution.friendlyPaymentMethod = "Stripe"
              }


              if ( contribution.cart && contribution.cart.length > 0 ){

              contribution.cart.forEach(cartItem => {
                if (!cartItem.giftId) {
                  cartItem.giftId = cartItem.gift.id;
                }
              });
              contribution.cart.forEach(cartItem => {
                cartItem.gift = gifts ? gifts.filter(
                  gift => (gift.id === cartItem.giftId)
                )[0] : null;

              });
            }
              counter++;
              contributionCount++;
              return contribution;

            }
          }
        }).filter(n => n)


      })
  };


  updateUser(user: User): Promise<any> {
    return this.afs
      .doc<User>(`users/${user.uid}`)
      .update(user)
      .then(x => {
        return x;
      });
  }

  setRegistryName(registryName: string) {
    //
    this.registryByName(registryName)
      .take(1)
      .subscribe(registry => {
        //
        if (registry) {
          this.registrySource.next(registry);
        }
      });
  }


  markContributionAsDeleted(contribution: Contribution): Promise<void> {
    return this.afs.collection(this.tablename_processedPayments).doc(contribution.id).set({
      deleted: true

    }, { merge: true }).then(() => {

      let purchasedGift = this.gifts.filter(x => x.id == contribution.cart[0].giftId)[0];

      if (!purchasedGift.hidePrice) {
        purchasedGift.remaining = purchasedGift.remaining + contribution.giftTotal;

        if (purchasedGift.status == 'paid') {
          purchasedGift.status = 'active';
        }
      }
      return this.updateGift(purchasedGift, true).then(() => {
        return;
      })

    })

  }

  setGifts(registry: Registry) {
    this.giftsCollectionRef = this.afs.collection<Gift>('registry-gifts', ref =>
      ref.where('registryId', '==', registry.id)
    );
    let observable: Observable<Gift[]> = this.giftsForRegistry();
    observable.subscribe(gifts => {
      this.giftsSource.next(gifts);

      observable = null;
    });
  }

  setRegistryForUser(user: User) {
    this.registryForUser(user).subscribe(registry => {
      this.registrySource.next(registry);
      if (registry) {
        this.giftsCollectionRef = this.afs.collection<Gift>(
          'registry-gifts',
          ref => ref.where('registryId', '==', registry.id)
        );
      }
    });
  }





  cleanTitle(gift: Gift) {

    const ranges = [
      '[\u00A0-\u269f]',
      '[\u26A0-\u329f]',
      // The following characters could not be minified correctly
      // if specifed with the ES6 syntax \u{1F400}
      '[🀄-🧀]',
      '[\u{1F004}-\u{1F9C0}]'
    ];
    gift.friendlyUrl = gift.title.replace(new RegExp(ranges.join('|'), 'ug'), '').replace(/[^\w\s]/gi, '');

  }


  getGiftsforRegistry(registryId: string): Observable<Gift[]> {

    return this.afs
      .collection<Gift>('registry-gifts', ref =>
        ref.where('registryId', '==', registryId)
      )
      .valueChanges()
      .map(actions => {
        return actions
          .map(gift => {
            if (gift.remaining == null) {
              gift.remaining = gift.price;
            }
            const paidPercent =
              ((gift.price - gift.remaining) / gift.price) * 100;
            gift.paidPercent = parseInt(paidPercent.toString(), 0);
            //      if (this.price && )
            // const total = (this.price - this.remaining) / this.price * 100;
            // return parseInt(total.toString(), 0);

            if (!gift.status) {
              gift.status = 'active';
            }
            if (gift.title && !gift.friendlyUrl) {
              gift.friendlyUrl = gift.title
                .replace(/\s+/g, '-')
                .replace(/[^a-zA-Z0-9-. ]/g, '');
            }
            
            // Migrate imageUrl to Gumlet
            if (gift.imageUrl) {
              gift.imageUrl = this.imageUrlService.migrateToGumlet(gift.imageUrl);
            }
            
            return gift;
          })
          .sort(function (a, b) {
            return b.createdDate - a.createdDate;
          });
      });
  }

  giftsForRegistry(): Observable<Gift[]> {

    return this.giftsCollectionRef.valueChanges().map(actions => {
      return actions
        .map(gift => {
          if (gift.remaining == null) {
            gift.remaining = gift.price;
          }
          const paidPercent =
            ((gift.price - gift.remaining) / gift.price) * 100;
          gift.paidPercent = parseInt(paidPercent.toString(), 0);
          //      if (this.price && )
          // const total = (this.price - this.remaining) / this.price * 100;
          // return parseInt(total.toString(), 0);
          if (gift.title && !gift.friendlyUrl) {
            gift.friendlyUrl = gift.title
              .replace(/\s+/g, '-')
              .replace(/[^a-zA-Z0-9-. ]/g, '');
          }

          if (!gift.status) {
            gift.status = 'active';
          }
          if (gift.title && !gift.friendlyUrl) {
            gift.friendlyUrl = gift.title.replace(/\s+/g, '-');
          }
          
          // Migrate imageUrl to Gumlet
          if (gift.imageUrl) {
            gift.imageUrl = this.imageUrlService.migrateToGumlet(gift.imageUrl);
          }
          
          return gift;
        })
        .sort(function (a, b) {
          return b.createdDate - a.createdDate;
        });
    });
  }

  // getGiftTemplatesFromMasterRegistry():  Observable<Gift[]> {
  //   const masterRegistryId = "";
  //   let gifts = this.afs.collection<Gift>('registry-gifts', ref =>
  //   ref.where('registryId', '==', masterRegistryId)


  // );

  //}
  // this.todo$ = this.firestoreService.col$<Todo>('todos');

  registryByName(registryName: string): Observable<Registry> {

    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries, ref =>
        ref.where('registryName', '==', registryName.toLowerCase())
      )
      .snapshotChanges()
      .map(x => {
        if (x && x.length > 0 && x[0].payload) {
          const registry = x[0].payload.doc.data() as Registry;
          registry.id = x[0].payload.doc.id;

          registry.symbol = this.currencySymbol(registry);
          this.cleanXssFromRegistry(registry);
          // Migrate backgroundHeaderImageUrl domain only
          if (registry.backgroundHeaderImageUrl) {
            registry.backgroundHeaderImageUrl = this.migrateImageUrlDomain(registry.backgroundHeaderImageUrl);
          }
          // Migrate profileImageUrl domain only
          if (registry.profileImageUrl) {
            registry.profileImageUrl = this.migrateImageUrlDomain(registry.profileImageUrl);
          }
          this.registrySource.next(registry);
          if(registry && registry.currency){
            registry.currency = registry.currency.toUpperCase();
          }
          this.registry = registry;

        
          return registry;
        }
      });
  }


  cleanXssFromRegistry(registry: Registry) {
    registry.introTitle = this.escapeOutput(registry.introTitle);
    registry.firstName = this.escapeOutput(registry.firstName)
    registry.partnerFirstName = this.escapeOutput(registry.partnerFirstName)
    //registry.registryName = this.escapeOutput(registry.registryName)
    registry.customInstructions = this.escapeOutput(registry.customInstructions)
    registry.introductionText = this.escapeOutput(registry.introductionText)
  }

  private readonly HOSTNAME_MAPPINGS = {
    'hitchd-cdn.imgix.net': 'hitchd.gumlet.io',
    'hitchd-cdn2.imgix.net': 'hitchd.gumlet.io', 
    'local-hitchd.imgix.net': 'kentand.gumlet.io'
  };

  private migrateImageUrlDomain(url: string): string {
    if (!url) return url;
    try {
      const urlObj = new URL(url);
      const currentHostname = urlObj.hostname;
      if (this.HOSTNAME_MAPPINGS[currentHostname]) {
        urlObj.hostname = this.HOSTNAME_MAPPINGS[currentHostname];
        return urlObj.toString();
      }
      return url;
    } catch (error) {
      console.warn('Failed to parse URL for domain migration:', url, error);
      return url;
    }
  }

  escapeOutput(toOutput) {

    if (!toOutput) return

    return toOutput
      // .replace(/\&/g, '&amp;')
      .replace(/\</g, '&lt;')
      .replace(/\>/g, '&gt;')
    // .replace(/\"/g, '&quot;')
    // .replace(/\'/g, '&#x27')
    // .replace(/\//g, '&#x2F');
  }

  generateGift(
    title,
    giftTypeSelection,
    price: number,
    location,
    description,
    imageUrl,
    category,
    videoUrl = null
  ): Gift {


    const gift = new Gift();
    gift.price = price;
    gift.description = description;
    gift.title = title;
    gift.imageUrl = imageUrl;
    gift.category = category;
    gift.createdFromGiftAssistant = true;
    gift.editedAfterGiftAssistant = false;
    gift.giftTypeSelection = giftTypeSelection;
    // ;
    gift.videoUrl = videoUrl;



    if (giftTypeSelection === 'Cash Fund') {
      gift.hidePrice = true;
      gift.price = 99999;
    }
    return gift;
  }

  getSampleGifts(currentGifts: Gift[], registry: Registry): Gift[] {
    let gifts = new Array<Gift>();
    let masterGiftTemplateString = localStorage.getItem('template-gifts');
    // let sampleGiftTitles = [ 'Honeymoon Fund', 'Airbnb', 'Flights','OURS Premarital Experience', 'Romantic Dinner', 'Road Trip']
    let sampleGiftTitles = ['Honeymoon Fund', 'Airbnb', 'Flights', 'Romantic Dinner', 'Road Trip']
    if (masterGiftTemplateString) {

      let templateGifts: Gift[] = JSON.parse(masterGiftTemplateString);

      if (!templateGifts) { return; }


      gifts = templateGifts.filter((template) =>
        sampleGiftTitles.includes(template.title)
      );

      // let oursGift = gifts.filter(item => item.title == "OURS Premarital Experience")[0];
      // gifts = gifts.filter(item => item.title !== "OURS Premarital Experience");
      // //data.unshift("role");
      // gifts.push(oursGift)
      // gifts = gifts.reverse();
      if (!currentGifts || currentGifts.length == 0) {
        return gifts;
      }
      const remainingSampleGifts = gifts.filter(x => !currentGifts.map(y => y.title).includes(x.title))
      return remainingSampleGifts;
    }

  }
  getHitchdReccomendedTemplates(currentGifts: Gift[], registry: Registry): TemplateGift[] {
    let gifts = new Array<TemplateGift>();
    let masterGiftTemplateString = localStorage.getItem('template-gifts');
    let sampleGiftTitles = [
      // 'OURS Premarital Experience',
      'Honeymoon Fund',
      'Flights',
      'Road Trip',
      'Airbnb',
      'Romantic Dinner',
      "Couple's Spa",
      "Happy Hour",
      "Adventure",
      "Charity",
    ];



    if (masterGiftTemplateString) {

      let templateGifts: TemplateGift[] = JSON.parse(masterGiftTemplateString);

      if (!templateGifts) { return; }


      sampleGiftTitles.forEach(title => {
        let gift = templateGifts.filter(x => x.title == title)[0];
        gifts.push(gift);
      })


      return gifts;
      //   if (!currentGifts || currentGifts.length == 0) {
      //     return gifts;
      //   }
      //   const remainingSampleGifts = gifts.filter(x => !currentGifts.map(y => y.title).includes(x.title));

      //   return remainingSampleGifts;
    }

  }
  doesUrlContainDefaultWords(registryName){
    return this.words.some(word => registryName.toLowerCase().includes(word))
  }

  generateUniqueUrlPath() {
    let randomThreeDigitNumber = Math.floor(Math.random() * 900) + 100;
    let urlPath = '';
    for (let i = 0; i < 3; i++) {
      const randomIndex = Math.floor(Math.random() *this.words.length);
      try{
      urlPath += this.words[randomIndex].replace(/\s/g, '').toLowerCase();
      } catch(e){
        //randomnumber and random letters
        console.log(e)
        urlPath += Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15 );
        
      }
      if (i < 2) {
        urlPath += '';
      }
    }
    return urlPath + randomThreeDigitNumber;
  }
  
  createDefaultGifts(callback, registry: Registry, currentGifts: Gift[],) {
    let gifts = this.getSampleGifts(currentGifts, registry);
    //let oursGift = gifts.find(x=>x.title.toLowerCase().includes("OURS"))

    return Promise.all(gifts.map(gift => {

      let fromSource = "sample-gifts";

      const templateId = gift.id;
      gift.fromRegistry = fromSource
      gift.templateGiftId = templateId;
      gift.fromTemplate = true;
      gift.id = null;
      const giftJson = JSON.parse(JSON.stringify(gift));
      this.addGift(giftJson, registry);
      console.log(5)
      this._analyticsService.trackEvent('Gift Created', {
        title: gift.title,
        created_from: 'sample_gift',
        template_id: gift.templateGiftId,
        templateName: gift.title
      })



    })).then(callback);

  }

  createDefaultGiftsLocally(callback, registry: Registry, currentGifts: Gift[],) {
    let gifts = this.getSampleGifts(currentGifts, registry);
    //let oursGift = gifts.find(x=>x.title.toLowerCase().includes("OURS"))

    return Promise.all(gifts.map(gift => {

      let fromSource = "sample-gifts";

      const templateId = gift.id;
      gift.fromRegistry = fromSource
      gift.templateGiftId = templateId;
      gift.fromTemplate = true;
      gift.id = null;
      const giftJson = JSON.parse(JSON.stringify(gift));
      this.addGiftLocally(giftJson)
      console.log(4)
      this._analyticsService.trackEvent('Gift Created', {
        title: gift.title,
        created_from: 'sample_gift',
        template_id: gift.templateGiftId,
        templateName: gift.title
      })



    })).then(callback);

  }


  regforUser(): Observable<Registry> {

    return this._authService.user.switchMap(user => {
      return this.registryForUser(user);
    });
  }

  registryByUserId(userId: string): Observable<Registry> {
    if (!userId) {
      return Observable.of(null);
    }

    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries, ref =>
        ref.where('userId', '==', userId)
      )
      .snapshotChanges()
      .map(x => {
        if (x && x.length > 0 && x[0].payload.doc.exists) {
          
          const registry = x[0].payload.doc.data() as Registry;
          registry.id = x[0].payload.doc.id;
          registry.symbol = this.currencySymbol(registry);
          // Migrate backgroundHeaderImageUrl domain only
          if (registry.backgroundHeaderImageUrl) {
            registry.backgroundHeaderImageUrl = this.migrateImageUrlDomain(registry.backgroundHeaderImageUrl);
          }
          // Migrate profileImageUrl domain only
          if (registry.profileImageUrl) {
            registry.profileImageUrl = this.migrateImageUrlDomain(registry.profileImageUrl);
          }
          return registry;
        }
        return null;
      });
  }


  registryForUser(user: User): Observable<Registry> {
    //

    if (user && user.registryId) {
      this.user = user;

      return this.afs
        .doc<Registry>(
          this.firebaseTableNames_Registries + '/' + user.registryId
        )
        .snapshotChanges()
        .map(x => {
          //
          if (x.payload.exists) {
            const registry = x.payload.data() as Registry;
            registry.id = x.payload.id;
            registry.symbol = this.currencySymbol(registry);
            if(registry && registry.currency){
              registry.currency = registry.currency.toUpperCase();
            }
            // Migrate backgroundHeaderImageUrl domain only
            if (registry.backgroundHeaderImageUrl) {
              registry.backgroundHeaderImageUrl = this.migrateImageUrlDomain(registry.backgroundHeaderImageUrl);
            }
            // Migrate profileImageUrl domain only
            if (registry.profileImageUrl) {
              registry.profileImageUrl = this.migrateImageUrlDomain(registry.profileImageUrl);
            }
            this.registry = registry;
            this.registrySource.next(registry);
            return registry;
          }
        });
    }
    else {

      return Observable.of(null);
    }
  }

  addImage(image: Upload): Promise<any> {
    image.file = null;
    return this.afs
      .collection<any>('gift-photos')
      .add({
        url: image.url,
        name: image.name
      })
      .then(x => {
        return x;
      });
  }

  createRegistry(formValue: any, user: User): Promise<any> {


    return new Promise((resolve, reject) => {

      const registry = JSON.parse(formValue);
      registry.paid = false;
      const regId = this.afs.createId();
      registry.id = regId;
      registry.isLive = true;

      if (registry.referalUserId) {
        user.referalUserId = registry.referalUserId;
      }
      //registry.layout = 'balanced';
      this.setCreated(registry, user.uid);
      //      ;
      this.registryForUser(user).take(1).subscribe(reg => {
        if (!reg) {
          this.afs
            .doc<Registry>(this.firebaseTableNames_Registries + '/' + regId)
            .set(registry)
            .then(x => {
              user.registryId = regId;
              this.cleanXssFromRegistry(registry);
              if(registry && registry.currency){
                registry.currency = registry.currency.toUpperCase();
              }
              this.registry = registry;
              const data = JSON.parse(JSON.stringify(user));
            
              this.afs
                .doc<User>(`users/${user.uid}`)
                .set(data)
                .then(() => {
                  // Create settings document after user document is created
                  const userSettings = {
                    // an object
                    emailGuestPays: true,
                    emailWhenRsvpReceived: true,
                    emailUpdates: true,
                    feeOption: 2,
                    userId: this.user.uid
                  };
                  this.afs
                    .doc(`settings/`+registry.id + user.uid)
                    .set(userSettings)
                    .then(() => {
                      console.log('settings created', userSettings);
                      return resolve(registry);
                    });
                });
            });
        }
      });

    });


  }

  UpdateHeaderBackgroundImage(
    backgroundUrl: string,
    videoUrl: string,
    locations: string[] = null
  ): Promise<boolean> {
    const welcomeText =
      'Your presence is present enough, but for those who wish to contribute, please choose a gift from our honeymoon';
    const defaultHeaderImg =
      'https://images.unsplash.com/photo-1505388944068-75420a859303?hex=#1A1E1B';
    if (this.user) {
      const registryObservable = this.registryForUser(this.user);

      if (locations) {
        locations = locations.filter(x => x !== 'isRegion');
      }

      let updated = false;
      if (this.user) {
        registryObservable.subscribe(registry => {
          if (!updated) {
            const savedRegistry = registry;
            if (locations) {
              if (registry.giftAssistantLocations) {
                locations = locations.filter(x => !registry.giftAssistantLocations.includes(x));
              }
              if (!savedRegistry.giftAssistantLocations) {
                savedRegistry.giftAssistantLocations = locations;
              } else {
                savedRegistry.giftAssistantLocations = savedRegistry.giftAssistantLocations.concat(
                  locations
                );
              }

              if (savedRegistry.introductionText.startsWith(welcomeText)) {
                let locString = savedRegistry.giftAssistantLocations[0];

                if (savedRegistry.giftAssistantLocations.length > 1) {
                  locString =
                    savedRegistry.giftAssistantLocations.slice(0, savedRegistry.giftAssistantLocations.length - 1).join(', ') +
                    ' and ' +
                    locations.slice(-1);
                }
                locString = locString.replace(', and', ' and');


                savedRegistry.introductionText =
                  welcomeText + ' to ' + locString + '.';
              }
            }
            
            if (
              !locations ||
              savedRegistry.backgroundHeaderImageUrl === defaultHeaderImg
            ) {


              savedRegistry.backgroundHeaderImageUrl = backgroundUrl? backgroundUrl: null ;
              savedRegistry.backgroundHeaderVideoUrl = videoUrl? videoUrl: null ;;
              savedRegistry.hasUpdatedRegistry = true;
            }

          
            this.setUpdated(savedRegistry);
            updated = true;
            savedRegistry.imageRepositionZoom = 1;
            savedRegistry.imageRepositionLeft = 50;
            savedRegistry.imageRepositionUp = 50;
            return this.afs
              .collection<Registry>(this.firebaseTableNames_Registries)
              .doc(registry.id)
              .update(savedRegistry)
              .then(x => {
                this._analyticsService.update(savedRegistry);
                return Promise.resolve(true);
              });
          }
        });
      } else {
        return Promise.resolve(null);
      }
    }
  }


  trialLeft(registry: Registry) {
    const regExpDate = new Date(new Date(registry.createdDate).getTime() + (3600 * 1000 * 24 * 7));
    const days: number = (regExpDate as any - (new Date().getTime() as any)) as any / (1000 * 3600 * 24);
    return Math.ceil(days);
  }
  saveRegistry(registry: Registry): Promise<any> {

    if(registry.defaultMode){
      registry.defaultMode = false;
    }

    this.setUpdated(registry);
    const data = JSON.parse(JSON.stringify(registry));
    this._analyticsService.update(registry);
    this.cleanXssFromRegistry(registry);
    if(registry && registry.currency){
      registry.currency = registry.currency.toUpperCase();
    }
    this.registry = registry;
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .update(data)
      .then(x => {
        return x;
      });
  }

  updateRegistry(formValue: any, user: User, registry: Registry): Promise<any> {

    const registryForm = JSON.parse(formValue);
    this.setUpdated(registryForm);
    registryForm.id = registry.id;
    if(registry.defaultMode){
      registry.defaultMode = false;
    }
    this._analyticsService.update(registry);
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .update(registryForm)
      .then(x => {

        this.registrySource.next(registry);
        return x;
      });
  }

  setAsDoneGiftAssistant(
    user: User,
    registryId: string,
    usedGiftAssistant: boolean
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registryId)
      .update({
        usedGiftAssistant: usedGiftAssistant
      })
      .then(x => {
        return this.afs
          .collection<Registry>(this.firebaseTableNames_Registries)
          .doc(registryId)
          .snapshotChanges()
          .subscribe(registryDoc => {
            if (registryDoc) {
              const registry = registryDoc.payload.data() as Registry;
              this.registrySource.next(registry);
              return registry;
            }
          });
      });
  }

  updateHideRegistryIntroText(
    user: User,
    registryId: string,
    hideIntroText: boolean
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registryId)
      .update({
        hideIntroText: hideIntroText
      })
      .then(x => {
        return this.afs
          .collection<Registry>(this.firebaseTableNames_Registries)
          .doc(registryId)
          .snapshotChanges()
          .subscribe(registryDoc => {
            if (registryDoc) {
              const registry = registryDoc.payload.data() as Registry;
              this.registrySource.next(registry);
              return registry;
            }
          });
      });

  }
  updateRegColours(
    registry: Registry
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .set({

        backgroundColour: registry.backgroundColour ? registry.backgroundColour : null,
        textColour: registry.textColour ? registry.textColour : null,
      }, { merge: true }).then(() => {
        this._analyticsService.update(registry);
        this.registrySource.next(registry);
      });

  }



  updateZoom(
    registry: Registry
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .set({

        imageRepositionZoom: registry.imageRepositionZoom ? registry.imageRepositionZoom : 1,
        imageRepositionUp: registry.imageRepositionUp ? registry.imageRepositionUp : 50,
        imageRepositionLeft: registry.imageRepositionLeft ? registry.imageRepositionLeft : 50,

      }, { merge: true }).then(() => {
        this._analyticsService.update(registry);
        this.registrySource.next(registry);
      });

  }

  updateRegFont(
    registry: Registry
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .set({

        font: registry.font ? registry.font : 'classic',
        applyFontToGiftTitles: registry.applyFontToGiftTitles ? registry.applyFontToGiftTitles : false,

      }, { merge: true }).then(() => {
        this._analyticsService.update(registry);
        this.registrySource.next(registry);
      });

  }


  updateRegLayout(
    registry: Registry
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .set({

        layout: registry.layout ? registry.layout : 'showcase',
        lightenCoverImage: registry.lightenCoverImage ? registry.lightenCoverImage : false,

      }, { merge: true }).then(() => {
        this._analyticsService.update(registry);
        this.registrySource.next(registry);
      });
  }



  updateRegIntro(
    registry: Registry
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .set({
        introductionText: registry.introductionText ? registry.introductionText : '',
        hideHashtag: registry.hideHashtag ? registry.hideHashtag : false,
        hashtag: registry.hashtag ? registry.hashtag : '',
        hideIntroText: registry.hideIntroText ? registry.hideIntroText : false,
        hasUpdatedRegistry: true,
        introductionTextTranslation: registry.introductionTextTranslation ? registry.introductionTextTranslation : '',
        translationLanguage: registry.translationLanguage ? registry.translationLanguage : '',
        weddingDay: registry.weddingDay,
        weddingMonth: registry.weddingMonth,
        weddingYear: registry.weddingYear,
        firstName: registry.firstName,
        partnerFirstName: registry.partnerFirstName,


      }, { merge: true })
      .then(x => {
        return this.afs
          .collection<Registry>(this.firebaseTableNames_Registries)
          .doc(registry.id)
          .snapshotChanges()
          .subscribe(registryDoc => {
            if (registryDoc) {
              const registry = registryDoc.payload.data() as Registry;
              this._analyticsService.update(registry);
              this.registrySource.next(registry);
              return registry;
            }
          });
      });
  }

  updateReg(
    registry: Registry
  ): Promise<any> {
    Object.keys(registry).forEach(key => {
      if (registry[key] === undefined) {
        registry[key] = null;
      }
    });

    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .update(registry)
      .then(x => {
        return this.afs
          .collection<Registry>(this.firebaseTableNames_Registries)
          .doc(registry.id)
          .snapshotChanges()
          .subscribe(registryDoc => {
            if (registryDoc) {
              const registry = registryDoc.payload.data() as Registry;
              //setAny fields taht are undefined to null
       
              this._analyticsService.update(registry);
              this.registrySource.next(registry);
              return registry;
            }
          });
      });
  }
  updateRegistryProfilePic(
    user: User,
    registryId: string,
    profilePicUrl: string
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registryId)
      .update({
        profileImageUrl: profilePicUrl,
        hasUpdatedRegistry: true,
      })
      .then(x => {
        return this.afs
          .collection<Registry>(this.firebaseTableNames_Registries)
          .doc(registryId)
          .snapshotChanges()
          .subscribe(registryDoc => {
            if (registryDoc) {
              const registry = registryDoc.payload.data() as Registry;
              this._analyticsService.update(registry);
              this.registrySource.next(registry);
              return registry;
            }
          });
      });
  }
  updateWeddingDate(
    user: User,
    registryId: string,
    day: number,
    month: number,
    year: number
  ): Promise<any> {
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registryId)
      .update({
        weddingDay: day,
        weddingMonth: month,
        weddingYear: year
      })
      .then(x => {
        return this.afs
          .collection<Registry>(this.firebaseTableNames_Registries)
          .doc(registryId)
          .snapshotChanges()
          .subscribe(registryDoc => {
            if (registryDoc) {
              const registry = registryDoc.payload.data() as Registry;
              this.registrySource.next(registry);
              this._analyticsService.update(registry);
              return registry;
            }
          });
      });
  }

  removeGift(gift: Gift, registry: Registry): void {



    if (location.pathname.includes('/your-registry')) {
      return this.removeLocalGift(gift, true);
    }

    this.giftsCollectionRef = this.afs.collection<Gift>('registry-gifts', ref =>
      ref.where('registryId', '==', gift.registryId)
    );

    this.giftsCollectionRef
      .doc(gift.id)
      .delete()
      .then(x => {

        this._analyticsService.trackEvent('Gift Deleted', {
          fromTemplate: gift.fromTemplate,
          title: gift.title,
          template_id: gift.templateGiftId,
          templateName: gift.title,


        });

          if(registry && registry.sections){
          let secctionIndex =  registry.sections.findIndex(x=> x && x.giftIds && x.giftIds.length && x.giftIds.includes(gift.id));

          if(registry.sections[secctionIndex] &&  registry.sections[secctionIndex].giftIds &&  registry.sections[secctionIndex].giftIds.length > 0){
          registry.sections[secctionIndex].giftIds.splice(registry.sections[secctionIndex].giftIds.indexOf(gift.id),1);

          this.saveRegistry(registry);
        }
          }

          this._analyticsService.identifySegmentUserWithRegData(this.user, registry, 
            null, null, null,null, this.gifts.length);
        if (!registry) {
          return this.hasCreatedOrEditedGifts(gift.registryId);
        } else {
          return this.hasCreatedOrEditedGiftsWithRegistry(registry);
        }
      });
  }

  hasCreatedOrEditedGifts(registryId): Promise<any> {

    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registryId)
      .set({
        hasCreatedOrEditedGifts: true
      }, { merge: true });

  }
  hasCreatedOrEditedGiftsWithRegistry(registry: Registry): Promise<any> {

    if (registry && registry.hasCreatedOrEditedGifts) {
      return Promise.resolve();
    }
    if(registry.defaultMode){
      registry.defaultMode = false;
    }
    if (!registry.firstName) {
      registry.firstName = "You"
    }
    if (!registry.customInstructions) {
      registry.customInstructions = null;
    }



    if (!registry.partnerFirstName) {
      registry.partnerFirstName = "Partner"
    }


    registry.hasCreatedOrEditedGifts = true;
    return this.afs
      .collection<Registry>(this.firebaseTableNames_Registries)
      .doc(registry.id)
      .set(registry, { merge: true });

  }

  setCreated(baseObject: BaseObject, userId: string) {
    if (!userId) {
      throw new Error('no user ID supplied: Hitchd crash error');
    }

    const now = Date.now();
    baseObject.createdDate = now;
    baseObject.modifiedDate = now;
    baseObject.userId = userId;
  }
  setUpdated(baseObject: BaseObject) {
    const now = Date.now();
    baseObject.modifiedDate = now;
  }

  loadGift(gift: Gift) {
    this.selectedGift = gift;
  }

  ensureSettingsExists() { }

  saveSettings(settings: Settings): Promise<any> {
    this.setUpdated(settings);
    const data = JSON.parse(JSON.stringify(settings));
    data.userId = this.user.uid;

    if (!this.settingsDocumentId && this.user.registryId) {
      this.settingsDocumentId = this.user.registryId + this.user.uid;
    }

    if (!settings.id) {
      settings.id = this.settingsDocumentId;

      return this.afs
        .collection<Settings>(this.firebaseTableNames_Settings)
        .doc(this.settingsDocumentId)
        .set(data)
        .then(() => {
          this.updateFee(settings);
        });
    } else {
      return this.afs
        .collection<Settings>(this.firebaseTableNames_Settings)
        .doc(this.settingsDocumentId)
        .update(data)
        .then(() => {
          this.updateFee(settings);
        });
    }
  }

  // setupStripe(){
  //   var stripe = require("stripe")("sk_test_oxd7NS2fVauop4En1BBpXRyY");

  // stripe.accounts.create({
  //   country: "US",
  //   type: "standard",
  //   email: "person@example.edu"
  // });
  // }

  updateFee(settings: Settings) {
    let coupleFee = 0;
    let guestFee = 0;
    if (settings.feeOption === 1) {
      coupleFee = 8;
    } else if (settings.feeOption === 2) {
      coupleFee = 4;
      guestFee = 4;
    } else if (settings.feeOption === 3) {
      guestFee = 8;
    }
    this.afs
      .doc(this.firebaseTableNames_Registries + '/' + this.user.registryId)
      .update({
        guestFeePercent: guestFee,
        coupleFeePercent: coupleFee,
        modifiedDate: Date.now()
      });
  }

  hasFeaturedGifts() {
    const featuredGifts = this.gifts.filter(x => x.featuredGift);
    return featuredGifts.length > 0;
  }

  unfeatureExistinGift(featuredGifts: Gift[]) {
    return featuredGifts.forEach(gift => {
      gift.featuredGift = false;
      return this.updateGift(gift);

    });
  }

  featureGift(giftId: string, isAnonymous = false): Promise<any> {

    if (this.gifts && this.hasFeaturedGifts()) {
      const oldFeaturedGift = this.gifts.filter(x => x.featuredGift);


      return this.afs
        .collection<Gift>(this.firebaseGifts)
        .doc(giftId)
        .set({ featuredGift: true }, { merge: true }).then(() => {
          this.unfeatureExistinGift(oldFeaturedGift);
        });
    }
    else if (isAnonymous) {
      let gifts = this.getLocalGifts();

      gifts.forEach(gift => {
        if (gift.featuredGift) {
          gift.featuredGift = false;
          this.updateGiftLocally(gift);
        }
      })

      let giftToFeature = gifts.find(x => x.id == giftId);
      giftToFeature.featuredGift = true;
      this.updateGiftLocally(giftToFeature);
      this.giftsSource.next(this.gifts)

    }
    else {
      return this.afs
        .collection<Gift>(this.firebaseGifts)
        .doc(giftId)
        .set({ featuredGift: true }, { merge: true });
    }
  }

  updateGift(gift: Gift, skipUpdateRegCreatedOrEditiedGifts: boolean = false): Promise<any> {
    gift.title = gift.title.trim();
    //   this._authService.user.take(1).subscribe(user => {

    if (gift.category === undefined) {
      gift.category = null;

    }


    if (gift.type === undefined) {
      gift.type = null;
    }
    if (gift.createdFromGiftAssistant === undefined) {
      gift.createdFromGiftAssistant = null;
    }
    if (gift.website === undefined) {
      gift.website = null;
    }

    if (gift.editedAfterGiftAssistant === undefined) {
      gift.editedAfterGiftAssistant = null;
    }

    if (gift.showGiftAmount === undefined) {
      gift.showGiftAmount = null;
    }

    if (gift.featuredGift === undefined) {
      gift.featuredGift = null;
    }
    if (gift.description === undefined) {
      gift.description = null;
    }
    if (gift.location === undefined) {
      gift.location = null;
    }
    if (gift.titleTranslation === undefined) {
      gift.titleTranslation = null;
    }
    if (gift.descriptionTranslation === undefined) {
      gift.descriptionTranslation = null;
    }
    return this.afs
      .collection<Gift>(this.firebaseGifts)
      .doc(gift.id)
      .set(gift, { merge: true })
      .then(x => {
        this.giftsCollectionRef = this.afs.collection<Gift>(
          'registry-gifts',
          ref => ref.where('registryId', '==', gift.registryId)
        );
        return this.giftsForRegistry().subscribe(gifts => {
          this.giftsSource.next(gifts);
          this.gifts = gifts;

          if (!skipUpdateRegCreatedOrEditiedGifts) {
            return this.hasCreatedOrEditedGifts(gift.registryId);
          } else {
            return Promise.resolve();
          }

        });
      });
  }

  setSourceData(gift: Gift, registry: Registry) {
    if (registry.campaign) {
      gift.campaign = registry.campaign;
    }


    if (registry.source) {
      gift.source = registry.source;
    }


    if (registry.partnershipId) {
      gift.partnershipId = registry.partnershipId;
    }
  }

  cleanTitleString(title) {

    const ranges = [
      '[\u00A0-\u269f]',
      '[\u26A0-\u329f]',
      // The following characters could not be minified correctly
      // if specifed with the ES6 syntax \u{1F400}
      '[🀄-🧀]',
      '[\u{1F004}-\u{1F9C0}]'
    ];

    return title.replace(new RegExp(ranges.join('|'), 'ug'), '').replace(/[^\w\s]/gi, '').replace(/ /g, '-').toLowerCase();


  }

  duplicateGift(gift: Gift, gifts: Gift[], registry: Registry, router: Router, fromTempaltes: boolean = false, isAnonymous = false): Promise<any> {


    let giftCopy: Gift = { ...gift };

    giftCopy.id = null;
    let title;

    for (let i = 1; i <= 10; i++) {

      title = "";

      if (i == 1) {
        title = gift.title + " Copy"
      } else {
        title = gift.title + " Copy " + (i - 1)
      }
      let results = gifts.filter(x => x.title.toLowerCase() == title.toLowerCase())
      if (!results || !results.length) {
        break
      }
    }

    giftCopy.title = title;
    giftCopy.friendlyUrl = this.cleanTitleString(giftCopy.title);
    giftCopy.paidPercent = 0;
    giftCopy.remaining = giftCopy.price;
    giftCopy.featuredGift = false;
    if (!isAnonymous) {
      return this.addGift(giftCopy, registry).then(() => {
        if (!fromTempaltes) {
          router.navigateByUrl('/registry/' + giftCopy.friendlyUrl + "/edit?isDuplicate=1")
        } else {
          router.navigateByUrl('/registry/' + giftCopy.friendlyUrl + "/edit?giftTemplateId=" + gift.id + "&isDuplicate=1")
        }
      })
    } else {
      this.addGiftLocally(giftCopy);
      router.navigateByUrl('/your-registry/' + giftCopy.friendlyUrl + "/edit?giftTemplateId=" + gift.id + "&isDuplicate=1")
      return Promise.resolve(giftCopy)

    }
  }
  updateGiftLocally(gift: Gift) {

    if (!this.localGifts || !this.localGifts.length) {
      this.localGifts = new Array<Gift>();
    }
    gift.status = 'active';
    if (!gift.id) {
      gift.id = 'temp_' + new Date().getTime();
    }
    var foundIndex = this.localGifts.findIndex(x => x.id == gift.id);
    this.localGifts[foundIndex] = gift;
    localStorage.setItem('local-gifts', JSON.stringify(this.localGifts))
    this.giftsSource.next(this.gifts)
  }

  // transferLocalGiftsToFirebase(){
  //   let localGifts = this.getLocalGifts();
  //   if (!localGifts || !localGifts.length ){
  //     return;
  //   }
  //   localGifts.forEach(localGift => {
  //     if (localGift.id.includes('temp_')) {          
  //         localGift.anonGiftId  =   localGift.id ;
  //         localGift.id = null;
  //     }
  //     this.addGift
  //   });




  transferLocalGiftsToFirebase(callback, registry: Registry) {
    let localGiftObject = this.getLocalGifts();
    if (!localGiftObject) {
      return;
    }
    let localGifts = [...this.getLocalGifts()];
    if (!localGifts || !localGifts.length) {
      return;
    }

    return Promise.all(localGifts.map(localGift => {


      const giftJson = JSON.parse(JSON.stringify(localGift));

      this.addGift(giftJson, registry);
      this.localGifts = this.localGifts.filter(x => x.id != localGift.id)
      localStorage.setItem('local-gifts', JSON.stringify(this.localGifts))
      console.log(3)
      this._analyticsService.trackEvent('Gift Created', {
        title: localGift.title,
        created_from: 'transfer_from_local_gift',
        template_id: localGift.templateGiftId,
        templateName: localGift.title
      })



    })).then(() => {
      if (this.registry) {
        this.saveRegistry(this.registry)
      }
    }

    ).then(callback);

  }

  removeLocalGift(gift: Gift, nonTemplateGift = false) {

    if (!this.localGifts || !this.localGifts.length) {
      this.localGifts = new Array<Gift>();
    }
    if (!nonTemplateGift) {
      this.localGifts = this.localGifts.filter(x => x.templateGiftId != gift.id);
    }
    if (nonTemplateGift) {
      this.localGifts = this.localGifts.filter(x => x.id != gift.id);
    }
    localStorage.setItem('local-gifts', JSON.stringify(this.localGifts))
    this.giftsSource.next(this.localGifts);
    this._analyticsService.trackEvent('Gift Deleted', {
      fromTemplate: gift.fromTemplate,
      title: gift.title,
      template_id: gift.templateGiftId,
      templateName: gift.title,
      anonymous_reg: true


    });

    return;
  }

  addGiftLocally(gift: Gift) {

    if (!this.localGifts || !this.localGifts.length) {
      this.localGifts = new Array<Gift>();
    }
    gift.status = 'active';
    if (!gift.id) {
      gift.id = 'temp_' + new Date().getTime();
    }
    gift.remaining = gift.price;
    gift.paidPercent = 0;
    this.localGifts.push(gift);
    localStorage.setItem('local-gifts', JSON.stringify(this.localGifts))
    console.log(2)
    this._analyticsService.trackEvent('Gift Created', {

      title: gift.title,
      created_from: gift.fromTemplate ? 'gift_templates' : 'custom_gift',
      template_id: gift.templateGiftId ? gift.templateGiftId : false,
      templateName: gift.title ? gift.title : null,
      anonymous_reg: true
    });

    let registry = this.getAnonRegistry();
    if (registry && !registry.hasCreatedOrEditedGifts) {
      registry.hasCreatedOrEditedGifts = true;
      this.saveAnonRegistry(registry);
    }
    this.giftsSource.next(this.localGifts);
  }

  getLocalGifts() {
    if (!this.localGifts) {

      let giftString = localStorage['local-gifts'];
      if (giftString) {
        this.localGifts = JSON.parse(giftString) as Gift[]
      }
    }
    return this.localGifts;

  }
  propergateRegistrtyObservable(registry: Registry) {
    this.registrySource.next(registry);
  }
  geneerateFriendlyUrl(title: string, gifts: Gift[]) {
    let friendlyUrl = this.cleanTitleString(title);
    let originalUrl = this.cleanTitleString(title);
    let version = 1;

  
    while (this.friendlyUrlExists(friendlyUrl, gifts)) {
      friendlyUrl = this.incrementFriendlyUrl(originalUrl, version);
      version++;
    }
  
    return friendlyUrl;
  }
  
  friendlyUrlExists(friendlyUrl: string, gifts: Gift[]): boolean {

    return gifts.some(gift => gift.friendlyUrl === friendlyUrl);
  }
  
  incrementFriendlyUrl(friendlyUrl: string, version: number): string {
    return friendlyUrl + version;
  }
  switchImage(gift: Gift) {
    if (gift.giftImageUrls && gift.giftImageUrls.length > 0) {
      // Find current image position in the array
      const currentIndex = gift.giftImageUrls.indexOf(gift.imageUrl);
      
      // Calculate next index (loop back to 0 if at the end)
      const nextIndex = (currentIndex + 1) % gift.giftImageUrls.length;
      
      // Set the new image URL
      gift.imageUrl = gift.giftImageUrls[nextIndex];
    }
    this.updateGift(gift);
  }

  resetGiftImage(gift: Gift) {
    
    if (gift.giftImageUrls && gift.giftImageUrls.length > 0) {
      gift.imageUrl = gift.giftImageUrls[0];
    }
    this.updateGift(gift);
  }

  identifyGiftTotals(registry: Registry, totalGifts: number){
    if(this.registry &&this.user && totalGifts){
      this._analyticsService.identifySegmentUserWithRegData(this.user, registry,     null, null, null,null, totalGifts);    
    }
  }

  addGift(gift: Gift, registry: Registry, preSetGiftId:string = null, skipIdentify:boolean = false): Promise<any> {
    //
    if (gift && gift.id && gift.id.includes('temp_')) {
      gift.anonGiftId = gift.id;
      gift.id = null;
    }
    if (registry) {
      this.setSourceData(gift, registry);

      gift.title = gift.title.trim();
      if (gift.category === undefined) {
        gift.category = null;
      }
      if (gift.description === undefined) {
        gift.description = null;
      }
      if (gift.location === undefined) {
        gift.location = null;
      }
      if (gift.titleTranslation === undefined) {
        gift.titleTranslation = null;
      }
      if (gift.descriptionTranslation === undefined) {
        gift.descriptionTranslation = null;
      }

      if (gift.createdFromGiftAssistant === undefined) {
        gift.createdFromGiftAssistant = null;
      }

      if (gift.editedAfterGiftAssistant === undefined) {
        gift.editedAfterGiftAssistant = null;
      }

      gift.friendlyUrl = this.geneerateFriendlyUrl(gift.title, this.gifts);


      gift.title = gift.title.trim();

      
      if (!skipIdentify){
      this._analyticsService.identifySegmentUserWithRegData(this.user, registry,     null, null, null,null, this.gifts.length);
      }
      if (gift.id == null) {

        if(preSetGiftId){
          gift.id = preSetGiftId;
        } else {
          gift.id = this.afs.createId();
        }
        

        if (this.registry && this.registry.giftSort) {
          let sortItemIndex = this.registry.giftSort.indexOf(gift.anonGiftId);
          if (sortItemIndex) {
            this.registry.giftSort[sortItemIndex] = gift.id;
          }
        }
        gift.registryId = registry.id;
        // gift.remaining = gift.price;
        gift.status = 'active';
        this.setCreated(gift, registry.userId);
        // ;
        return this.giftsCollectionRef
          .doc(gift.id)
          .set(gift)
          .then(x => {
            if (!gift.createdFromGiftAssistant) {
              return this.hasCreatedOrEditedGiftsWithRegistry(registry);
            } else {
              return x;
            }

          })
          .catch(error => {
            throw new Error(error);
          });
      } else {
        this.setUpdated(gift);
        this.giftsCollectionRef
          .doc(gift.id)
          .update(gift)
          .then(x => {
            this.giftsCollectionRef = this.afs.collection<Gift>(
              'registry-gifts',
              ref => ref.where('registryId', '==', registry.id)
            );
            this.giftsForRegistry()
              .take(1)
              .subscribe(gifts => {
                this.gifts = gifts;

                return this.hasCreatedOrEditedGiftsWithRegistry(registry);


              });

            return x;
          })
          .catch(error => { });
      }
    }
  }
  addGiftIdToSection(sectionName:string, registry:Registry, giftId:string){

    let section:Section
    if (registry && registry.sections){
      section  = this.registry.sections.filter(section => section.name == sectionName)[0]
    } else {
      this.registry.sections = new Array<Section>();
    }
    if (!section ){
      section = {
        name: sectionName,
        giftIds: new Array<string>()
      }
      section.giftIds.unshift(giftId);
      this.registry.sections.unshift(section);
    }
    else if (!section.giftIds || section.giftIds.length == 0){
      section.giftIds = new Array<string>();
      section.giftIds.unshift(giftId);
    } else{
   
    this.registry.sections.filter(section => section.name == sectionName)[0].giftIds.unshift(giftId);
    }
    this.saveRegistry(this.registry);

  }
  addPayment() {
    // let test = this.selectedGift.paid + this.paymentAmount ;
    // this.selectedGift.paid = test;
    this.giftsCollectionRef.doc(this.selectedGift.id).update({ paid: true });
    this.paymentCollectionRef.add({
      id: null,
      giftId: this.selectedGift.id,
      amount: this.paymentAmount
    });
  }

  // Add this method
  getInitialMiniLaunchState(): Observable<[boolean, boolean]> {
    return this.initialMiniLaunchState.asObservable();
  }

  // Add this to update the state
  showMiniLaunchPopup(show: boolean, isWebsite: boolean = false): void {
    this.showMiniLaunchChanged.next([show, isWebsite]);
    this.initialMiniLaunchState.next([show, isWebsite]);
  }

  // Add this new method
  showMoveGiftModal(gift: Gift): void {
    this.moveGiftToSectionSource.next(gift);
  }
}



// WEBPACK FOOTER //
// ./src/app/registry/registry-firebase.service.ts